var render = function render(_c,_vm){return _c('span',[_vm._v(" "+_vm._s(_vm.$options.methods.formatDate(_vm.props.start))+" - "),(_vm.props.end)?[_vm._v(_vm._s(_vm.$options.methods.formatDate(_vm.props.end)))]:[_vm._v(" "+_vm._s(_vm.parent.$t('internalstock.unlimited_information'))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }